import React from 'react';
import { motion } from 'framer-motion';
import { Sparkles } from 'lucide-react';
export function AnnouncementBar() {
  return <motion.div initial={{
    y: -40,
    opacity: 0
  }} animate={{
    y: 0,
    opacity: 1
  }} transition={{
    duration: 0.6,
    ease: 'easeOut'
  }} className="bg-sage text-white py-2.5 px-4 relative overflow-hidden" data-id="element-15">
      <div className="max-w-6xl mx-auto flex items-center justify-center gap-3 text-sm md:text-base" data-id="element-16">
        <motion.div animate={{
        rotate: [0, 15, 0, -15, 0]
      }} transition={{
        duration: 2.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-17">
          <Sparkles className="w-4 h-4 text-bronze-light" data-id="element-18" />
        </motion.div>

        <span className="font-medium tracking-wide text-center" data-id="element-19">
          <span className="hidden sm:inline" data-id="element-20">⏰ Oferta de lanzamiento — </span>
          Guía + 3 bonos{' '}
          <span className="line-through opacity-60 mx-1" data-id="element-21">$77.00</span>
          <motion.span animate={{
          opacity: [1, 0.6, 1]
        }} transition={{
          duration: 2,
          repeat: Infinity,
          ease: 'easeInOut'
        }} className="text-cream font-bold" data-id="element-22">
            Solo $14.00
          </motion.span>
          <span className="hidden md:inline" data-id="element-23"> — Precio sube pronto</span>
        </span>

        <motion.div animate={{
        rotate: [0, -15, 0, 15, 0]
      }} transition={{
        duration: 2.5,
        repeat: Infinity,
        ease: 'easeInOut'
      }} data-id="element-24">
          <Sparkles className="w-4 h-4 text-bronze-light" data-id="element-25" />
        </motion.div>
      </div>
    </motion.div>;
}